import { render, staticRenderFns } from "./demand_info.vue?vue&type=template&id=23759ca9&scoped=true&"
import script from "./demand_info.vue?vue&type=script&lang=js&"
export * from "./demand_info.vue?vue&type=script&lang=js&"
import style0 from "./demand_info.vue?vue&type=style&index=0&id=23759ca9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23759ca9",
  null
  
)

export default component.exports